!(function () {
  'use strict';
  /* @preserve
   * https://github.com/Elkfox/Ajaxinate
   * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
   * MIT License (do not remove above copyright!)
   */ function e(e) {
    const t = e || {};
    ((this.settings = Object.assign(
      {
        method: 'scroll',
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        offset: 0,
        loadingText: 'Loading',
        loadAll: !1,
        callback: null,
      },
      t
    )),
      (this.addScrollListeners = this.addScrollListeners.bind(this)),
      (this.addClickListener = this.addClickListener.bind(this)),
      (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
      (this.preventMultipleClicks = this.preventMultipleClicks.bind(this)),
      (this.removeClickListener = this.removeClickListener.bind(this)),
      (this.removeScrollListener = this.removeScrollListener.bind(this)),
      (this.removePaginationElement = this.removePaginationElement.bind(this)),
      (this.hidePaginationButtons = this.hidePaginationButtons.bind(this)),
      (this.setPaginationLoadingState = this.setPaginationLoadingState.bind(this)),
      (this.destroy = this.destroy.bind(this)),
      (this.containerElement = document.querySelector(this.settings.container)),
      (this.paginationElement = document.querySelector(this.settings.pagination)),
      this.initialize());
  }
  ((e.prototype.initialize = function () {
    if (!this.containerElement) return;
    ({ click: this.addClickListener, scroll: this.addScrollListeners })[this.settings.method]();
  }),
    (e.prototype.hidePaginationButtons = function () {
      if (!this.paginationElement) return;
      const e = this.paginationElement.querySelector('[data-ajaxinate-next]');
      const t = this.paginationElement.querySelector('[data-ajaxinate-view-all]');
      e && e.remove();
      t && t.remove();
      this.paginationElement.classList.add('is-complete');
      this.paginationElement.setAttribute('data-ajaxinate-complete', 'true');
    }),
    (e.prototype.setPaginationLoadingState = function (e) {
      this.paginationElement &&
        (this.paginationElement.classList.toggle('is-loading', !!e),
        this.paginationElement.setAttribute('aria-busy', e ? 'true' : 'false'));
      this.nextPageLinkElement &&
        (this.nextPageLinkElement.classList.toggle('is-loading', !!e),
        this.nextPageLinkElement.setAttribute('aria-busy', e ? 'true' : 'false'));
    }),
    (e.prototype.addScrollListeners = function () {
      this.paginationElement &&
        (document.addEventListener('scroll', this.checkIfPaginationInView),
        window.addEventListener('resize', this.checkIfPaginationInView),
        window.addEventListener('orientationchange', this.checkIfPaginationInView));
    }),
    (e.prototype.addClickListener = function () {
      this.paginationElement &&
        ((this.nextPageLinkElement = this.paginationElement.querySelector('[data-ajaxinate-next]')),
        (this.clickActive = !0),
        void 0 !== this.nextPageLinkElement &&
          null !== this.nextPageLinkElement &&
          this.nextPageLinkElement.addEventListener('click', this.preventMultipleClicks));
    }),
    (e.prototype.preventMultipleClicks = function (e) {
      (e.preventDefault(),
        this.clickActive &&
          (this.setPaginationLoadingState(!0),
          (this.nextPageUrl = this.nextPageLinkElement.href),
          (this.clickActive = !1),
          this.loadMore()));
    }),
    (e.prototype.checkIfPaginationInView = function () {
      const e = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
        t = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
      e <= window.innerHeight &&
        t >= 0 &&
        ((this.nextPageLinkElement = this.paginationElement.querySelector('[data-ajaxinate-next]')),
        this.removeScrollListener(),
        this.nextPageLinkElement &&
          (this.setPaginationLoadingState(!0),
          (this.nextPageUrl = this.nextPageLinkElement.href),
          this.loadMore()));
    }),
    (e.prototype.loadMore = function () {
      ((this.request = new XMLHttpRequest()),
        (this.request.onreadystatechange = function () {
          if (!this.request.responseXML) return;
          if (4 === !this.request.readyState || 200 === !this.request.status) return;
          const e = this.request.responseXML.querySelectorAll(this.settings.container)[0],
            t = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
          (this.containerElement.insertAdjacentHTML('beforeend', e.innerHTML),
            void 0 === t
              ? (this.setPaginationLoadingState(!1), this.removePaginationElement())
              : ((this.paginationElement.innerHTML = t.innerHTML),
                this.setPaginationLoadingState(!1),
                // Reset clickActive after successful load in click mode
                this.settings.method === 'click' && (this.clickActive = !0),
                this.settings.callback &&
                  'function' == typeof this.settings.callback &&
                  this.settings.callback(this.request.responseXML),
                this.initialize(),
                this.settings.loadAll &&
                  ((this.nextPageLinkElement =
                    this.paginationElement.querySelector('[data-ajaxinate-next]')),
                  this.nextPageLinkElement && this.nextPageLinkElement.href
                    ? ((this.nextPageUrl = this.nextPageLinkElement.href),
                      this.setPaginationLoadingState(!0),
                      this.loadMore())
                    : this.removePaginationElement()),
                // In both click and loadAll modes, if no next page remains, hide only the buttons.
                this.paginationElement.querySelector('[data-ajaxinate-next]') ||
                  this.hidePaginationButtons()));
        }.bind(this)),
        this.request.open('GET', this.nextPageUrl),
        (this.request.responseType = 'document'),
        this.request.send());
    }),
    (e.prototype.removeClickListener = function () {
      // Guard: nextPageLinkElement can be null when the last page is reached
      // (Clarity reported this as a recurring JS error causing dead Load More clicks)
      this.nextPageLinkElement && this.nextPageLinkElement.removeEventListener('click', this.preventMultipleClicks);
    }),
    (e.prototype.removePaginationElement = function () {
      // Keep the viewing info; only remove action buttons.
      (this.hidePaginationButtons(), this.destroy());
    }),
    (e.prototype.removeScrollListener = function () {
      (document.removeEventListener('scroll', this.checkIfPaginationInView),
        window.removeEventListener('resize', this.checkIfPaginationInView),
        window.removeEventListener('orientationchange', this.checkIfPaginationInView));
    }),
    (e.prototype.destroy = function () {
      return (
        { click: this.removeClickListener, scroll: this.removeScrollListener }[
          this.settings.method
        ](),
        this
      );
    }),
    customElements.get('ajaxinate-items') ||
      customElements.define(
        'ajaxinate-items',
        class extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          startLoadAll() {
            if (!this.endlessScroll || !this.endlessScroll.paginationElement) return;

            this.endlessScroll.settings.loadAll = !0;
            this.endlessScroll.clickActive = !0; // Reset clickActive when switching to loadAll mode
            this.endlessScroll.nextPageLinkElement =
              this.endlessScroll.paginationElement.querySelector('[data-ajaxinate-next]');
            if (
              this.endlessScroll.nextPageLinkElement &&
              this.endlessScroll.nextPageLinkElement.href
            ) {
              this.endlessScroll.nextPageUrl = this.endlessScroll.nextPageLinkElement.href;
              this.endlessScroll.setPaginationLoadingState(!0);
              this.endlessScroll.loadMore();
            }
          }
          updateViewingInfo() {
            const t = this?.dataset.ajaxinateId,
              e = document.querySelector(`#AjaxinateLoop[data-ajaxinate-id="${t}"]`),
              i = document.querySelector(`#AjaxinatePagination[data-ajaxinate-id="${t}"]`);
            if (!e || !i) return;

            const n = parseInt(i?.dataset?.collectionTotal || '0', 10);
            if (!n) return;

            // Count only product cards (exclude featured image blocks)
            const o = e.querySelectorAll('.grid-item.product-item').length;
            const a = Math.min(o, n);

            const s = i.querySelector('[data-viewing-start]');
            const r = i.querySelector('[data-viewing-end]');
            if (s) s.textContent = o > 0 ? '1' : '0';
            if (r) r.textContent = String(a);
          }
          attachViewAllListener() {
            const t = this?.dataset.ajaxinateId;
            const viewAllBtn = document.querySelector(
              `#AjaxinatePagination[data-ajaxinate-id="${t}"] [data-ajaxinate-view-all]`
            );
            if (viewAllBtn && !viewAllBtn.dataset.listenerAttached) {
              viewAllBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.startLoadAll();
              });
              viewAllBtn.dataset.listenerAttached = 'true';
            }
          }
          init() {
            this.endlessScroll = null;
            const t = this?.dataset.ajaxinateId,
              i = `#AjaxinateLoop[data-ajaxinate-id="${t}"]`,
              n = `#AjaxinatePagination[data-ajaxinate-id="${t}"]`;
            const o = this?.dataset.ajaxinateMethod || 'scroll';
            const a = 'true' === this?.dataset.ajaxinateLoadAll;
            this?.children.length > 0 &&
              ((this.endlessScroll = new e({
                container: i,
                pagination: n,
                method: o,
                loadAll: a,
                callback: () => {
                  this.updateViewingInfo();
                  this.attachViewAllListener(); // Re-attach after each page load
                },
              })),
              this.updateViewingInfo(),
              // Bind "View all" click to load all remaining pages
              this.attachViewAllListener(),
              // If already configured to load all, start immediately
              a && this.startLoadAll());
          }
          reinit() {
            (this.unload(), this.init());
          }
          unload() {
            null !== this.endlessScroll &&
              ((this.endlessScroll.settings.method = 'scroll'),
              this.endlessScroll.destroy(),
              (this.endlessScroll = null));
          }
          disconnectedCallback() {
            this.unload();
          }
        }
      ));
})();
